export default __webpack_public_path__ + "static/media/icaew_xl3.f541eb92.png";